import * as React from "react";
import { Select, MenuItem, InputLabel, makeStyles, Checkbox } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  textField: {
    textAlign: 'left',
    width: 200,
  },
  inputMargin: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  }
}));

// NOTE // takes in a defaultVal (the value it's changing), handleChange (the state-management function), inputLabel, and items
// NOTE // (e.g.) <SelectWithLabel defaultVal={depAirport} handleChange={changeAirportRq} inputLabel={'Airport'} items={airNorthAirports}/> 
export const SelectWithLabelAndCheckbox = (props) => {
  let defaultVal = props.defaultVal
  let handleChange = props.handleChange
  let inputLabel = props.inputLabel

  let width = props.width
  // NOTE // set multiple to true to have multi-select (changes selected items to an array)
  let multiple = props.multiple || false
  // NOTE // items should be an array of objects with a label and value (e.g. [{label: 'none', value: null}, {label: 'active', value: true}])
  let items = props.items

  const classes = useStyles();
  const id = inputLabel.toLowerCase().replace(' ', '-')

  return (
    <div className={classes.inputMargin} style={{ width: `${width ? width: ''}`}}>
      {/* NOTE // neeeded to use in-line styling to override textAlign */}
      <InputLabel style={{textAlign: 'left'}} shrink id={id + '-label-placeholder'}>{inputLabel}</InputLabel>
      <Select
        labelId={id + '-label'}
        id={id}
        value={defaultVal}
        onChange={handleChange}
        displayEmpty
        multiple={multiple}
        renderValue={(selected) => selected.join(', ')}
        className={classes.textField}
      >
        {items.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            <Checkbox checked={defaultVal.includes(item.value)} />
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}